import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/access-requests?paginate=true`

    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.status) !== 'undefined' && params.status !== null) {
      url = `${url}&status=${params.status}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  update({ tenantID, requestID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/access-requests/${requestID}`,
      method: 'patch',
      data
    })
  },
  destroy({ tenantID, requestID }) {
    return authenticated({
      url: `/tenants/${tenantID}/access-requests/${requestID}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/access-requests.js